var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "role-list" }, [
    _c("div", { staticClass: "role-list-content" }, [
      _c("div", { staticClass: "role-header" }, [_vm._v("请选择商家身份")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "role-search" },
        [
          _c("div", { staticClass: "role-search_label" }, [_vm._v("商家名称")]),
          _vm._v(" "),
          _c("ks-input", {
            staticClass: "role-search_input",
            attrs: { placeholder: "搜索商家名称" },
            model: {
              value: _vm.keyword,
              callback: function($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword"
            }
          }),
          _vm._v(" "),
          _c(
            "ks-button",
            {
              staticClass: "role-search_btn",
              attrs: { type: "primary" },
              on: { click: _vm.searchRole }
            },
            [_vm._v("搜索")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "role-table" }, [
        _c("div", { staticClass: "role-table_header" }, [_vm._v("店铺名称")]),
        _vm._v(" "),
        _c(
          "div",
          { ref: "role-table_content", staticClass: "role-table_content" },
          [
            _c(
              "div",
              { ref: "role-table_cell" },
              [
                _vm._l(_vm.singedMerchants, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: item.ksUserId,
                      staticClass: "role-table_item",
                      on: {
                        click: function($event) {
                          return _vm.selectRole(index)
                        }
                      }
                    },
                    [
                      _c("div", {
                        class: ["select", { selected: item.selected }]
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(item.merchantName))])
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isLoading,
                      expression: "isLoading"
                    }
                  ],
                  staticClass: "loading"
                })
              ],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "role-paginagtion" },
        [
          _c("ks-pagination", {
            attrs: {
              background: "",
              layout: "total,prev, pager, next",
              total: _vm.totalNum
            },
            on: { "current-change": _vm.handlePageClick }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "role-submit-wrapper" },
      [
        _c(
          "ks-button",
          {
            staticClass: "role-submit",
            attrs: { type: "primary", disabled: !_vm.selectIndex },
            on: { click: _vm.submit }
          },
          [_vm._v("确认")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }